var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deals-page"},[_c('div',{staticClass:"header"}),(_vm.isAccess)?_c('selected'):_vm._e(),(!_vm.isAccess)?_c('login-required'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }